import { handleWindow } from "@/utils";

enum PATH_TYPE {
  login = '/login',
  register = '/register',
  bindPhone = '/binding/phone',
  logout = '/logout',
}

const userCenter = (backUrl=handleWindow().location.href) => {
  const t = new Date().getTime();
  // const url = (pathType: PATH_TYPE) => `${process.env.USER_CENTER_HOST}${pathType}?appId=${process.env.USER_CENTER_APP_ID}&backUrl=${handleWindow().location.href}&locale=zh_CN&mode=redirect&autologin=y&t=${t}`
  const url = (pathType: PATH_TYPE) => `${process.env.USER_CENTER_HOST}${pathType}?appId=${process.env.USER_CENTER_APP_ID}&backUrl=${encodeURIComponent(backUrl)}&locale=zh_CN&mode=redirect&autologin=y&t=${t}`

  return {
    login: url(PATH_TYPE.login),
    register: url(PATH_TYPE.register),
    bindPhone: url(PATH_TYPE.bindPhone),
    logout: url(PATH_TYPE.logout),
  }
}

export default userCenter;

// https://account.dbeta.me/login?appId=bbs_dbeta_me&backUrl=https://bbs.dbeta.me/forum.php?mobile=yes&locale=zh_CN&mode=redirect&autologin=y&t=1702384760
// https://account.dbeta.me/login?appId=bbs_dbeta_me&backUrl=https://bbs.dbeta.me/&locale=zh_CN&mode=redirect&autologin=y&t=1702385089
// https://account.dji.com/binding/phone?locale=zh_CN&backUrl=https%3A%2F%2Fm.skypixel.com%2Fapi%2Fv2%2Fcallback%2Fbind-phone%2Fnew-home

